import React, { Component } from 'react'
import { Row, Col, Button, Tabs, Input, Tag, Form, notification } from 'antd';
import { Link } from 'react-router-dom';
import { pathOr } from 'ramda';
import algoliaENV from '../../../algolia'
import axios from 'axios';
import MediaQuery from 'react-responsive'
import Drawer from 'rc-drawer'
import {fbFunctionsURL} from '../../../firebase.js';
let close = '/images/icon/close.svg'
let menu = '/images/icon/menu.svg'

const { TabPane } = Tabs;
const Search = Input.Search;
const client = algoliaENV;

class Header extends Component {
 state = {
    suggestionBox: false,
    suggestionShow: false,
    selectedTags: [],
    searchTerm: false,
    openResponsive: false
  }

  searchFocus = (searchBy) => {
    const { history, authenticated } = this.props
    if (!authenticated && searchBy === 'education' || !authenticated && searchBy === 'branch') {
      history.push('/signup');
    } else {
      if(searchBy !== "jobs") {
        this.setState({ suggestionBox: true });
        this.searchOnChange('', searchBy);
      }
    }
  }

  searchOnChange = (event, searchBy) => {
    let value = pathOr('', ['target', 'value'], event)
    const { current_user } = this.props

    if(searchBy !== 'jobs'){
      const index = client.initIndex(current_user && current_user.role === 'company' ? 'users' : (searchBy === "company" ? 'company' : 'job_posting' ));
      const this_function = this;
      index.searchForFacetValues(
        {
          facetName: current_user && current_user.role === 'company' ? 'profile.'+searchBy : (searchBy === "company" ? 'companyname' : searchBy),
          facetQuery: value,
        },
        function searchDone(err, content) {
          if (err) throw err;

          this_function.setState({
            suggestionShow: content.facetHits,
            searchTerm: searchBy
          })
        }
      );
    }
  }

  searchByJobTitle = (value, searchBy) => {
    const { current_user, history } = this.props
    const this_state = this;
    let filterDisabledJobs = '';

    Object.keys(pathOr({}, ['disabledJobs'], current_user)).forEach((i,index,user) => {
      if (index === Object.keys(pathOr({}, ['disabledJobs'], current_user)).length - 1){
        filterDisabledJobs += 'NOT objectID:'+ user[index];
      }else{
        filterDisabledJobs += 'NOT objectID:'+ user[index] +' AND ';
      }
    })
    if(searchBy === "jobs"){
      const index = client.initIndex(current_user && current_user.role === 'company' ? 'users' : 'job_posting');
      index.search(value,
      {
        "restrictSearchableAttributes": current_user && current_user.role === 'company' ? (value ? "profile.current_job" : "") : (value ? "job_title" : ""),
        'filters': filterDisabledJobs,
        "numericFilters": [
          "status !=0"
         ]
      },
      function searchDone(err, content) {
        if (err) throw err;
        this_state.props.history.push({
          pathname: '/search/?searchBy='+searchBy+'&jobTitleSearch='+value,
          searchResults: content.hits
        })
      }
    );
    }
  }

  goToSearch = () => {
    const { current_user } = this.props
    const { selectedTags, searchTerm } = this.state;
    let indexBy = current_user&& current_user.role === 'company'
      ? 'users'
      : (searchTerm === "company" ? 'company' : 'job_posting' )

    const index = client.initIndex(indexBy);
    const filter = [];
    this.setState({
      suggestionBox: false
    });

    selectedTags.forEach(function(tag) {
      filter.push((current_user && current_user.role === 'company' ? 'profile.'+searchTerm : (searchTerm === "company" ? "companyname" : searchTerm )) +":"+tag)
    });
    index.search("",
      {
        "facetFilters": [filter],
        "numericFilters": [
          "status !=0"
         ]
      },
      (err, content) => {
        if (err) throw err;
        this.props.history.push({
          pathname: '/search' + (searchTerm === "company" ? '/company' : "/") + '?searchBy='+searchTerm+'&selectedTags='+encodeURIComponent(selectedTags),
          searchResults: content.hits
        })
      }
    );
  }

  addTags = (value) => {
    let { selectedTags, suggestionShow } = this.state;
    const combined_array = [...selectedTags, value];
    this.setState({
      selectedTags: combined_array.filter((v,i) => combined_array.indexOf(v) === i)
    //  suggestionShow
    })
  }

  clearTags = () => {
    this.setState({selectedTags: []})
  }

  handleCloseEdu = (removedTag) => {
    const selectedTags = this.state.selectedTags.filter(tag => tag !== removedTag);
    this.setState({ selectedTags });
  }

  searchBlur = () => {
    this.setState({
      suggestionBox: false
    })
  }

  handleNewsLetter = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const config = {
          url: `${fbFunctionsURL}/cronJob/sendNewsLetterMail`,
          method: 'POST',
          data: values,
          headers: {
            'Content-Type': 'application/json',
          }
        };
        axios(config)
        .then((response) => {
          const { data } = response;
          notification['success']({
            message: 'Email & Naam successfully submited!'
          });
          this.props.form.resetFields();
          // console.log(data)
        })
        .catch((error) => {
          console.log(error);
        });
      }
    });
  };

  menu = [
    { name: 'Home', to: '/about-us' },
    { name: 'About', to: '/about' },
    { name: 'Team', to: '/team' },
    { name: 'FAQ', to: '/faq' },
    { name: 'Contact', to: '/contact-us' },
  ]

  render() {
    const {authenticated, firebase, current_user, t, form:{getFieldDecorator}} = this.props
    const {suggestionBox, suggestionShow, selectedTags, searchTerm} = this.state
    let customClassName = suggestionBox ? "header-main-search move-box-up" : "header-main-search move-box-down"
      return (
        <Row>
          <Col span={24}>
            <div className="main-bg">
            <div onClick={this.searchBlur} className={"headerSearchOverlay" + (suggestionBox && " headerSearchOverlayDisplay") }></div>

              <Col xs={{ span: 22 }} sm={{ span: 22 }} md={{ span: 22 }} lg={{ span: 12 }} className="header-search-box">
                <div className={customClassName}>
                  {/* <div className="logo-landing-page" /> */}
                  <Tabs defaultActiveKey="1" onChange={evt => this.setState({ suggestionBox: false })}>
                    <TabPane tab={t("Jobs")} key="1">
                      <div className="tabs-main">
                        <Search
                          placeholder={t("Job title or keywords")}
                          className="header-main-jobs"
                          onSearch={value => this.searchByJobTitle(value, "jobs")}
                        />
                      </div>
                    </TabPane>
                    {((current_user && current_user.role === "candidate") || !authenticated) &&
                      <TabPane tab={t("Company")} key="2">
                        <div className="tabs-main">
                          <Search
                            placeholder={t("Search for company")}
                            className="header-main-jobs"
                            onChange={value => this.searchOnChange(value, 'company') }
                            onFocus={() => this.searchFocus('company')}
                          />
                        </div>
                      </TabPane>
                    }
                    {((current_user && current_user.role === "company")) &&
                      <TabPane tab={t("preferred_job")} key="5">
                        <div className="tabs-main">
                          <Search
                            placeholder={t("Search by Preferred Job")}
                            className="header-main-jobs"
                            onFocus={() => this.searchFocus('preferred_job')}
                          />
                        </div>
                      </TabPane>
                    }
                    {((current_user && current_user.role === "company") || !authenticated) &&
                      <TabPane tab={t("Sector")} key="3">
                        <div className="tabs-main">
                          <Search
                            placeholder={t("Search by Sectors")}
                            className="header-main-jobs"
                            onFocus={() => this.searchFocus('branch')}
                          />
                        </div>
                      </TabPane>
                    }
                    {((current_user && current_user.role === "company") || !authenticated) &&
                      <TabPane tab={t("Education")} key="4">
                        <div className="tabs-main">
                          <Search
                            placeholder={t("Search by Education")}
                            className="header-main-jobs"
                            onFocus={() => this.searchFocus('education')}
                          />
                        </div>
                      </TabPane>
                    }
                  </Tabs>
                    {suggestionBox &&
                      <div className="searchSuggestions">
                      <Col className="suggestion" xs={{ span: 24, offset: 0 }} lg={{ span: 14, offset: 0 }}>
                        <div className="suggestionTitle">
                          {t("Suggestion")}
                        </div>
                        <div className="suggestionParent">
                          {suggestionShow && suggestionShow.map((suggestion, index) => {
                            if (suggestion && suggestion.hidden !== true ) {
                              return (
                                <div key={index} onClick={() => this.addTags(suggestion['value'])}>
                                  {suggestion['value']}
                                </div>
                              )
                            }
                          })}
                        </div>
                      </Col>
                      <Col className="suggestion" xs={{ span: 24, offset: 0 }} lg={{ span: 10, offset: 0 }}>
                        <div className="suggestionTitle spaceBetween">
                          {console.log(searchTerm)}
                          <span>{'Geselecteerde'} {t(searchTerm)}</span>
                          <span onClick={() => this.clearTags()} className="clearBtn">{'Wis alles'}</span>
                        </div>
                        <div className="addedTagsParent">
                          {selectedTags && selectedTags.map((tag, index) => {
                            return (
                              <Tag className="tagDesign" key={tag} closable={true} onClose={() => this.handleCloseEdu(tag)}>
                                <div className="tabDesigText">{tag}</div>
                              </Tag>
                            )
                          })}
                        </div>
                        <Button onClick={this.goToSearch} className="headerSearchButton" type="primary-global">{t('Search')}</Button>
                      </Col>
                      </div>
                    }
                </div>
              </Col>
            </div>
          </Col>
          <Drawer
            wrapperClassName="contactMenuDrawer"
            placement="right"
            handler={false}
            level={null}
            open={this.state.openResponsive}
          >
            <div style={{ position: 'fixed', right: 0, bottom: 10 }}>
              <ul className="navigation-mobile">
                {this.menu.map(item => (
                  <li key={item.name} className={`nav-item`}>
                    <Link
                      {...item}
                      className={`navi-link-mobile`}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
                <li style={{float: 'right'}}>
                  <Link to="/signup">
                    <Button style={{marginRight:'25px' }} type="primary-global medium" className="header-main-signup">{t("Create Account")}</Button>
                  </Link>
                </li>
                <li style={{float: 'right'}}>
                  <Link to="/login">
                    <Button className="header-main-signin">{t("sign_in")}</Button>
                  </Link>
                </li>
              </ul>
            </div>
          </Drawer>
        </Row>
      )
  }
}

export default (Form.create()(Header))
